import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { appRouter } from './App';
import { RouterProvider } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

root.render(<RouterProvider router={appRouter} />);
